import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _BusinessCoreForAccountant, _MovementsForAccountant } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectAccountantIDType } from "../../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/ComponentPrepaidPayment/SelectAccountantIDType";
import { FileInput } from "../../../theme/Component/FileInput";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";



export const BusinessMovements = () => {

    const importbussines = useDataBean(_BusinessCoreForAccountant);
    const updatemovements = useDataBean(_MovementsForAccountant);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalimp, setModalimp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalupdate, setModalupdate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    // useEffect(() => {
    //     getLista();
    // }, [])
    const vermodalimp = () => {

        setModalimp({ ...modalimp, "view": true });
    }
    const vermodalupdate = () => {

        setModalupdate({ ...modalupdate, "view": true });
    }
    const importBusinessCoreForAccountantID = () => {

        importbussines.instance.importBusinessCoreForAccountantID(importbussines.bean.IDAccountantIDType, importbussines.bean.Media, importbussines.bean.MediaContext, null).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Importado');
                    setModalimp({ ...modalimp, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const updateMovementsForAccountantIDWithBusinessCore = () => {

        updatemovements.instance.updateMovementsForAccountantIDWithBusinessCore(updatemovements.bean.IDAccountantIDType, updatemovements.bean.Year, updatemovements.bean.Month).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Actualizado');
                    setModalupdate({ ...modalupdate, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }



    return (
        <BasicPage titulo="Actualizar Unidades de Negocio por Plan de Cuentas">
            <div className="row">
                <div className="col-md-6">
                    <BasicButton icon="ri-save-line" clase="primary" eventClick={vermodalimp}>Importar Unidades de Negocio a Cuentas Contables</BasicButton>
                    <Modal modal={modalimp} updateModal={setModalimp} eventModal={importBusinessCoreForAccountantID}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectAccountantIDType idSelector={importbussines.bean.IDAccountantIDType} onChange={(e) => { importbussines.setBean({ ...importbussines.bean, "IDAccountantIDType": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <FileInput
                                    Media={importbussines.bean.Media}
                                    MediaContext={importbussines.bean.MediaContext}
                                    directory='Template'
                                    label='Archivo'
                                    docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                    onCreate={(Filemap: any) => { importbussines.setBean({ ...importbussines.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                ></FileInput>
                            </div>
                        </div>
                    </Modal>
                </div>

                <div className="col-md-6">
                    <BasicButton icon="ri-save-line" clase="primary" eventClick={vermodalupdate}>Actualizar Unidades de Negocio</BasicButton>
                    <Modal modal={modalupdate} updateModal={setModalupdate} eventModal={updateMovementsForAccountantIDWithBusinessCore}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectAccountantIDType idSelector={updatemovements.bean.IDAccountantIDType} onChange={(e) => { updatemovements.setBean({ ...updatemovements.bean, "IDAccountantIDType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <YearSelector value={updatemovements.bean.Year} onChange={(e) => { updatemovements.setBean({ ...updatemovements.bean, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthConstantsEditor label='Mes' idSelect={updatemovements.bean.Month} onChange={(e) => { updatemovements.setBean({ ...updatemovements.bean, "Month": e }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}